import { render } from "./Landing.vue?vue&type=template&id=84469084"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"
script.render = render

export default script